/*
 * @Author: wangshengqiang
 * @Date: 2021-05-07 16:41:21
 * @LastEditTime: 2021-05-07 16:43:51
 * @LastEditors: wangshengqiang
 * @Description: 受益人信息确认
 */
import React, { useState } from 'react';
import { getState } from '@/store';
import { getEnumList, queryAttrs } from '@/services/dict';
import { getValuePath, isPreviewMode, isTemplateMode } from '@/utils/tool';
import Detail from './Detail';
export default function FieldValue(props) {
  const {
    data,
    label,
    value: name,
    dataSource
  } = props;
  let value = data[name];
  const [enumValue, setEnumValue] = useState();

  if (dataSource && dataSource.length && name !== 'occupation') {
    let enumItem = {};

    if (name === 'insurancePeriod' || name === 'paymentPeriod') {
      enumItem = dataSource.find(item => item.value.join('-') === value);
    } else {
      enumItem = dataSource.find(item => item.value == value);
    }

    if (enumItem) {
      value = enumItem.label;
    }
  } else {
    const rawValue = value || (() => {
      let codes = [data.provinceCode, data.cityCode, data.countyCode];

      if (name === 'insureRegion') {
        codes = [data.insureProvinceCode, data.insureCityCode, data.insureCountyCode];
      } else if (name === 'receiverRegion') {
        codes = [data.receiverProvinceCode, data.receiverCityCode, data.receiverCountyCode];
      }

      return codes.filter(item => item).join(',');
    })();

    if (name === 'occupation' && rawValue) {
      getEnumList('occupation').then(res => {
        if (res.success) {
          const valuePath = getValuePath(rawValue, res.result, 'code');

          if (valuePath && valuePath.length) {
            setEnumValue(valuePath[valuePath.length - 1].name);
          }
        }
      });
    }

    if ((name === 'region' || name === 'insureRegion') && rawValue) {
      getEnumList('district').then(res => {
        if (res.success) {
          const codeArr = rawValue.split(',');
          const valuePath = getValuePath(codeArr[codeArr.length - 1], res.result, 'code');

          if (valuePath && valuePath.length) {
            setEnumValue(valuePath.map(item => item.name).join('/'));
          }
        }
      });
    }

    if (name === 'nationality' && rawValue) {
      rawValue && getEnumList('country').then(res => {
        if (res.success) {
          const valuePath = getValuePath(+rawValue, res.result, 'code');

          if (valuePath && valuePath.length) {
            setEnumValue(valuePath[valuePath.length - 1].name);
          }
        }
      });
    }
  }

  if (name === 'drawerCertiType') {
    if (!isPreviewMode() && !isTemplateMode()) {
      queryAttrs({
        code: 'certiType',
        type: 1,
        holderType: 1
      }).then(_data => {
        if (_data.success) {
          const enumItem = _data.value.dataSource.find(item => item.value === value);

          if (enumItem) {
            setEnumValue(enumItem.label);
          }
        }
      });
    }
  }

  if (name === 'firstYearPremium') {
    value = getState('healthOrderDetail.premium');
  }

  return /*#__PURE__*/React.createElement(Detail, {
    label: label,
    value: enumValue === undefined ? value : enumValue
  });
}